export const REVIEW_ITEM_TYPES_FETCHED = 'REVIEW_ITEM_TYPES_FETCHED';
export const REVIEW_ITEM_TYPE_FETCHED = 'REVIEW_ITEM_TYPE_FETCHED';
export const REVIEW_ITEM_TYPE_ADD = 'REVIEW_ITEM_TYPE_ADD';
export const REVIEW_ITEM_TYPE_UPDATE = 'REVIEW_ITEM_TYPE_UPDATE';
export const REVIEW_ITEM_TYPE_REMOVE = 'REVIEW_ITEM_TYPE_REMOVE';
